import React, { useContext, useEffect } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import { VMContext } from "./vmContext";

function QuerySetAdd({ categoryTypeID }) {
  let VMContextdata = useContext(VMContext);

  let [QuerySetDetail, setQuerySetDetail] = React.useState({ name: "" });
  let [savingInfo, setsavingInfo] = React.useState({
    done: null,
    message: "",
  });
  let [QuerySetDetailCopy, setQuerySetDetailCopy] = React.useState({
    name: "",
  });

  async function hande_change(e) {
    let temp = JSON.parse(JSON.stringify(QuerySetDetail));
    temp[e.target.name] =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setQuerySetDetail(temp);
  }

  function has_changes() {
    return (
      JSON.stringify(QuerySetDetail) !== JSON.stringify(QuerySetDetailCopy)
    );
  }

  function cancel_changes() {
    let temp = JSON.parse(JSON.stringify(QuerySetDetailCopy));
    setQuerySetDetail(temp);
  }

  async function save_changes() {
    setsavingInfo(null);

    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let res = await ServiceWrapper.doPost(
      api_base_url + "versionmanagement/queryset/update",
      QuerySetDetail,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        setsavingInfo({
          done: true,
          message: res.data.message,
        });

        clear_form();
        VMContextdata.setQuerySetReleadCounter((n) => (n = 1));
      } else {
        setsavingInfo({
          done: false,
          message: res.data.message,
        });
      }
    } else {
      setsavingInfo({
        done: false,
        message: "Error while saving, Please try after some time.",
      });
    }
  }

  // function copy_QuerySet_detail() {
  //   let temp = JSON.parse(JSON.stringify(QuerySetDetail));
  //   setQuerySetDetailCopy(temp);
  // }

  async function clear_form() {
    let vform = {
      name: "",
    };
    await setQuerySetDetail((v) => vform);
    await setQuerySetDetailCopy((v) => vform);
  }

  useEffect(() => {
    clear_form();
  }, []);
  return (
    <React.Fragment>
      <>
        {/* {JSON.stringify(QuerySetDetail)} */}
        {/* {loading && (
          <div className="alert alert-primary bg-white sma  p-1" role="alert">
            <span className="fas fa-circle-notch fa-spin" />
            &nbsp;
            <strong>{loadingInfo}</strong>
          </div>
        )} */}

        <>
          {true && (
            <>
              <div className="row">&nbsp;</div>
              <div className="row gx-1 gy-1 align-items-center">
                {/* <strong>Add New Set : </strong> */}
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name"
                    placeholder="Enter Set Name"
                    value={QuerySetDetail.name}
                    onChange={(e) => hande_change(e)}
                  />
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-sm btn-success"
                    disabled={!has_changes()}
                    onClick={() => save_changes()}
                  >
                    <i className="fa fa-check" />
                    &nbsp; Save
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={() => cancel_changes()}
                    disabled={!has_changes()}
                  >
                    <i className="fa fa-undo" />
                    &nbsp; Cancel
                  </button>
                </div>
                <div className="col-auto">
                  {savingInfo !== null ? (
                    <>
                      {savingInfo.done ? (
                        <div
                          className="alert  alert-success small p-1"
                          role="alert"
                        >
                          <i className="far fa-check-circle" />
                          &nbsp;
                          <strong>{savingInfo.message}</strong>
                        </div>
                      ) : (
                        <>
                          {savingInfo.done === false && (
                            <div
                              className="alert alert-danger bg-white small p-1"
                              role="alert"
                            >
                              <span className="fas fa-exclamation-triangle" />
                              &nbsp;
                              <strong>{savingInfo.message}</strong>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <div
                        className="alert  alert-light small p-1"
                        role="alert"
                      >
                        <span className="fas fa-circle-notch fa-spin" />
                        &nbsp;
                        <strong>Saving your Changes</strong>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      </>
    </React.Fragment>
  );
}

export default QuerySetAdd;
